interface StorageKeys {
	language: string;
	idToken: string;
	accessToken: string;
	accessTokenExpiryDate: string;
	redirectUrl: string;
	role: string;
	gcToken: string;
	startDate: string;
	endDate: string;
}

export const STORAGE_KEYS: StorageKeys = {
	language: 'language',
	idToken: 'id_token',
	accessToken: 'access_token',
	accessTokenExpiryDate: 'expires_at',
	redirectUrl: 'redirect_url',
	role: 'role',
	gcToken: 'gc_token',
	startDate: 'start_date',
	endDate: 'end_date'
};



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/config/storage-keys.ts